import { Requirement } from '.prisma/client';
import { Injectable } from '@angular/core';
import { CreateHotToastRef, HotToastService } from '@ngneat/hot-toast';
import { of } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {
  createItemEffect,
  deleteItemEffect,
  loadListEffect,
  updateItemEffect,
} from '../../shared/crud/effects';
import {
  createItem,
  deleteItem,
  loadList,
  updateItem,
} from './requirement.actions';
import { RequirementRepository } from './requirement.repository';
import { RequirementService } from './requirement.service';

@Injectable({ providedIn: 'root' })
export class RequirementEffects {
  constructor(
    private repository: RequirementRepository,
    private service: RequirementService,
    private toast: HotToastService
  ) {}

  loadEntities$ = loadListEffect<Requirement>({
    action: loadList,
    repository: this.repository,
    serviceAction: () => this.service.findAll(),
    toast: this.toast,
  });

  createEntity$ = createItemEffect<Requirement>({
    action: createItem,
    repository: this.repository,
    serviceAction: (entity) => this.service.create(entity),
    toast: this.toast,
  });

  updateEntity$ = updateItemEffect<Requirement>({
    action: updateItem,
    repository: this.repository,
    serviceAction: (id, changes) => this.service.update(id, changes),
    toast: this.toast,
  });

  deleteEntity$ = deleteItemEffect<Requirement>({
    action: deleteItem,
    repository: this.repository,
    serviceAction: (id) => this.service.delete(id),
    toast: this.toast,
  });

  loadEntityById$ = (id: Requirement['id']) => {
    let toaster: CreateHotToastRef<unknown>;
    return of(id).pipe(
      switchMap((id) => {
        this.repository.updateStatus('item', 'pending');
        environment?.production ||
          (toaster = this.toast.loading(`Загрузка требования`));
        return this.service.findOne(id).pipe(
          tap((entity) => {
            if (!environment?.production) {
              this.toast.success(`Требование загружено`);
            }
            if (entity) {
              this.repository.updateEntity(entity.id, entity);
            }
          }),
          finalize(() => {
            toaster?.close();
          })
        );
      })
    );
  };
}
